if (!customElements.get('media-grid-layout')) {
  customElements.define('media-grid-layout', class MediaGridLayout extends HTMLElement {
    connectedCallback() {
      this.initializationFrame = requestAnimationFrame(() => {
        this.initializationFrame = null;
        if (this.isConnected) this.initializeLayout();
      });
    }

    initializeLayout() {
      this.adaptiveItems = Array.from(this.querySelectorAll('[data-image-aspect-ratio]'));
      if (!this.adaptiveItems.length) return;
      this.layoutItems = Array.from(this.querySelectorAll('.image-grid__item'));
      this.classList.add('image-grid__content-grid--adaptive');

      this.scheduleLayout = this.scheduleLayout || (() => {
        if (this.layoutFrame) return;
        this.layoutFrame = requestAnimationFrame(() => {
          this.layoutFrame = null;
          this.updateLayout();
        });
      });
      this.resizeObserver = new ResizeObserver(this.scheduleLayout);
      this.resizeObserver.observe(this);
      this.layoutItems.forEach((item) => this.resizeObserver.observe(item));
      window.addEventListener('resize', this.scheduleLayout);
      this.updateLayout();
    }

    disconnectedCallback() {
      if (this.initializationFrame) cancelAnimationFrame(this.initializationFrame);
      this.initializationFrame = null;
      this.resizeObserver?.disconnect();
      window.removeEventListener('resize', this.scheduleLayout);
      if (this.layoutFrame) cancelAnimationFrame(this.layoutFrame);
      this.layoutFrame = null;
    }

    updateLayout() {
      const styles = getComputedStyle(this);
      const rowHeight = parseFloat(styles.gridAutoRows);
      const gap = parseFloat(styles.getPropertyValue('--media-grid-active-vertical-gap')) || 0;
      if (!Number.isFinite(rowHeight) || rowHeight <= 0) return;

      const measurements = this.layoutItems.map((item) => ({ item, height: parseFloat(getComputedStyle(item).height) }));
      measurements.forEach(({ item, height }) => {
        if (!Number.isFinite(height) || height <= 0) return;
        const rowSpan = Math.max(1, Math.ceil((height + gap - 0.001) / rowHeight));
        if (item.style.getPropertyValue('--adaptive-row-span') !== String(rowSpan)) {
          item.style.setProperty('--adaptive-row-span', String(rowSpan));
        }
      });
    }
  });
}
